import * as React from 'react';
import { observer } from 'mobx-react';
import { classes, style } from 'typestyle';
import { colorSlate, colorSubtle, colorWhite } from '../theme/color';
import {em, important, percent, px, viewWidth} from 'csx';
import { shadowSubtle } from '../theme/shadow';
import { mediaTablet } from '../theme/media';
import { zToolip } from '../theme/z';
import {Modal} from './modal';
import {ModalChildStyle} from './modal';
import {colorContrast} from '../theme/color';
import {endJustified, horizontal, horizontallySpaced} from 'csstips';
import {ButtonPill} from './button-pill';
import {Component} from "react";

export interface TooltipProps {
  className?: string;
  content: string | Component | JSX.Element;
  dockRight?: boolean;
  i18n?: {
    close: string;
  }
  cursor?: string;
}

export interface TooltipState {
  show: boolean;
}

@observer
export class Tooltip extends React.Component<TooltipProps, TooltipState> {
  private $tooltip: HTMLDivElement;

  state = {
    show: false
  };

  render() {
    const { i18n = Tooltip.i18n, children, content, className } = this.props;
    const { show } = this.state;

    return (
      <span className={classes(Tooltip.styles.container, className)}>
        <span className={classes(Tooltip.styles.text, style({cursor: this.props.cursor || 'help'}))} onClick={show ? this.handleLeave : this.handleEnter}>{children}</span>
        {show && (
          <Modal show={show} onRequestClose={this.handleLeave}>
            <div className={Tooltip.styles.modalContainer}>
              <p>{content}</p>
              <div className={Tooltip.styles.buttons}>
                <ButtonPill onClick={this.handleLeave}>
                  {i18n.close}
                </ButtonPill>
              </div>
            </div>
          </Modal>
        )}
      </span>
    )
  }

  handleEnter = () => {
    if (this.state.show) return;

    this.setState({ show: true });
  };

  handleLeave = () => {
    if (!this.state.show) return;

    this.setState({ show: false});
  };

  static i18n = {
    close: 'OK'
  };

  static styles = {
    container: style({
      position: 'relative',
    }),
    modalContainer: style(ModalChildStyle, {
      ...ModalChildStyle,
      width: px(420),
      maxWidth: 'calc(100vw - 4rem)',
      background: colorSlate.toString(),
      overflowX: 'hidden',
      $nest: {
        '&> h3': {
          color: colorContrast.toString(),
          fontSize: px(30),
          margin: '0 0 30px 0',
        },
        '& p': {
          color: colorWhite.toString(),
          margin: '5px 0 30px 0',
          lineHeight: em(1.4)
        }
      }
    }),
    text: style({
      textDecoration: 'underline dotted',
    }),
    tooltip: style({
      display: 'none',
      position: 'absolute',
      color: colorWhite.toString(),
      fontSize: px(14),
      lineHeight: em(1.4),
      background: colorSlate.darken(0.05).toString(),
      padding: '7px 10px',
      whiteSpace: 'pre',
      borderRadius: px(2.01),
      boxShadow: shadowSubtle,
      top: percent(100),
      maxWidth: viewWidth(100),
      zIndex: zToolip,
    }),
    tooltipShow: style({
      display: important('block')
    }),
    close: style(
      {
        color: colorSubtle.toString(),
        fontSize: px(12),
        whiteSpace: 'pre'
      },
      mediaTablet({ display: 'none' })
    ),
    buttons: style({
      ...horizontal,
      ...horizontallySpaced(10),
      ...endJustified,
      margin: '30px 0 0 0'
    }),
  };
}